"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.factory = void 0;
var factory = {
  ICON_POSITION: {
    LEFT: 'left',
    RIGHT: 'right'
  },
  SCREEN_TYPE: {
    DESKTOP: 'desktop',
    IPAD: 'ipad',
    MOBILE: 'mobile'
  }
};
exports.factory = factory;